/* ── Shared navigation structure ─────────────────────────────────────────────
   Single source of truth for page ids and labels.
   Used by both Sidebar (to render nav items) and Topbar (to derive page title).
────────────────────────────────────────────────────────────────────────────── */

export const NAV_GROUPS = [
    {
        id: "orders-group",
        label: "Orders",
        icon: "orders",
        items: [
            { id: "orders", label: "All Orders" },
            { id: "place-order", label: "Place Order" },
            {
                id: "order-approvals?type=new",
                label: "Min Price Approval",
                roles: ["admin"],
            },
            {
                id: "order-approvals?type=edit",
                label: "Edit Request",
                roles: ["admin"],
            },
        ],
    },
    {
        id: "crm",
        label: "CRM",
        icon: "crm",
        items: [
            { id: "organisations", label: "Organizations" },
            { id: "crm-call-management", label: "CRM Call Management" },
            { id: "daily-call-tracker", label: "Daily Call Tracker" },
            { id: "not-ordering", label: "Not Ordering" },
        ],
    },
    {
        id: "sales",
        label: "Sales",
        icon: "sales",
        items: [
            { id: "visit-management", label: "Visit Management" },
            {
                id: "live-tracker",
                label: "Live Tracker",
                roles: ["admin", "sales_tl"],
            },
            {
                id: "distance-history",
                label: "Distance History",
                roles: ["admin", "sales_tl"],
            },
            { id: "retail-customers", label: "Retail Customers" },
            { id: "corporate-customers", label: "Corporate Customers" },
            {
                id: "customer-import",
                label: "Import Customers",
                roles: ["admin", "sales_tl"],
            },
            { id: "team-customers", label: "Leads Assignment" },
            { id: "team-management", label: "TL Management" },
            // { id: 'reports', label: 'Reports' },
        ],
    },
    {
        id: "location",
        label: "Location",
        icon: "location",
        items: [
            { id: "cities", label: "Cities" },
            { id: "parent-areas", label: "Parent Areas" },
            { id: "areas", label: "Areas" },
        ],
    },
    {
        id: "products",
        label: "Products",
        icon: "products",
        items: [
            { id: "products", label: "Product Catalog" },
            { id: "products/customizations", label: "Customizations" },
            { id: "products/categories", label: "Categories" },
        ],
    },
    {
        id: "accounts",
        label: "Accounts",
        icon: "accounts",
        items: [], // placeholder — routes to be added
    },
    {
        id: "warehouse",
        label: "Warehouse",
        icon: "warehouse",
        items: [{ id: "warehouse/stock", label: "Product Stock" }],
    },
    {
        id: "admin",
        label: "Admin",
        icon: "admin",
        items: [
            { id: "staffs", label: "Staffs" },
            { id: "roles", label: "Roles" },
            { id: "system-settings", label: "System Settings" },
            {
                id: "order-import",
                label: "Order Import",
                roles: ["software_developer"],
            },
            {
                id: "call-queue-import",
                label: "Call Queue Import",
                roles: ["software_developer"],
            },
            {
                id: "product-cost-import",
                label: "Product Cost Import",
                roles: ["software_developer"],
            },
        ],
    },
];

// Standalone pages not inside any group (used in Topbar title resolution)
export const STANDALONE_PAGES = [
    { id: "dashboard", label: "Dashboard" },
    { id: "customers", label: "Customers" },
    { id: "orders", label: "All Orders" },
    { id: "order-approvals", label: "Order Approvals" },
    { id: "place-order", label: "Place Order" },
    { id: "settings", label: "Settings" },
    { id: "alerts", label: "Alerts & Notifications" },
];

/** Flatten all nav items (including children) into a { id -> label } map for O(1) lookup */
export const PAGE_TITLES = Object.fromEntries([
    ...STANDALONE_PAGES.map((p) => [p.id, p.label]),
    ...NAV_GROUPS.flatMap((g) =>
        g.items.flatMap((i) => [
            [i.id, i.label],
            ...(i.children || []).map((c) => [c.id, c.label]),
        ]),
    ),
]);
